import { Typography } from "@/design-system/Atoms"; 

type PatientBillOfRightsLayoutProps = {
  heading?: string;
  content?: string | React.ReactNode;
  className?: string;
};

export const PatientBillOfRightsLayout = ({
  heading,
  content,
  className,
}: PatientBillOfRightsLayoutProps) => {
  return (
    <>
      <Typography
        variant="privacyPolicyTitle"
        as="div"
        className={`${className}`}
      >
        {heading}
      </Typography>

      <Typography variant="privacyPolicyDescription" as="p">
        {content}
      </Typography>
    </>
  );
};

export default PatientBillOfRightsLayout;
